import './css/UsuariosCaja.css';
import {Link} from 'react-router-dom';


function UsuariosCaja({rolNombre, cantidad, icon, info, id, configuracion}){
    

    return(
            <div className='caja' style={{border: `1px solid ${configuracion.color_principal}`}}>
                    <div className='caja-circulo-logo'style={{
                        backgroundColor: configuracion.color_secundario,
                        color:configuracion.color_sterciario,
                        border: `1px solid ${configuracion.color_principal}`
                        }}
                    ><i className={icon}></i></div>
                    <h6 className='caja-titulo' style={{color:configuracion.color_principal}}><strong>Rol {rolNombre}</strong></h6>
                    <hr></hr>
                    <div className='caja-cantidades' style={{color:configuracion.color_principal}}><span>{cantidad}</span> usuario/s </div>
                    <div className='text-center caja-botonera' style={{color:configuracion.color_principal}}><Link className='btn btn-sm btn-outline-secondary m-2' to={`/Usuarios/${id}`}><i className="fa-solid fa-magnifying-glass"></i> Ver todos</Link></div>
                    <div className='caja-info' style={{color:configuracion.color_principal}}><span><b>info reciente:</b><br/> {info}</span></div>
            </div>
    );
}

export default UsuariosCaja;